module.exports = __webpack_public_path__ + "img/logo-ascenti.cc548727.svg";